import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { useGuestLogin } from '@utils/hooks/useGuestLogin';
import { useServiceRedirect } from '@utils/hooks/useServiceRedirect';

import { getPath } from '@services/RouteService/paths';

import { FormBottomElement } from '@domains/auth/molecules/FormBottomElement/FormBottomElement';
import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';
import { GuestLoginForm } from '@domains/auth/organisms/GuestLoginForm/GuestLoginForm';

export const LoginSurveysGuestPage = () => {
    useServiceRedirect({ path: '/survey/list' });
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { openGuestModal, sessionProcessing } = useGuestLogin();

    return (
        <ColumnsLayout
            breadcrumb={t('LOGIN_SURVEYS_TITLE')}
            contentPadding={{
                bottom: 40,
                top: 16,
            }}
            title={t('LOGIN_SURVEYS_TITLE')}
        >
            <Card testId="oDXVa0k">
                <Card.TitleTertiary>
                    {t('CONTINUE_AS_A_GUEST')}
                </Card.TitleTertiary>
                <Card.Description>
                    {t('GUEST_REGISTER_DESCRIPTION')}
                </Card.Description>
                <GuestLoginForm
                    bottomElement={
                        <FormBottomElement
                            buttonText={t('GUEST_LOGIN')}
                            onSubmit={() =>
                                navigate(
                                    getPath({
                                        path: '/auth/see-active-surveys',
                                    }),
                                )
                            }
                        />
                    }
                    loading={sessionProcessing}
                    openGuestModal={openGuestModal}
                />
            </Card>
            <LoginBanner>
                <LoginBanner.Title>
                    <LoginBanner.Link to={getPath({ path: '/auth/signup' })}>
                        {t('CREATE_SPEEKI_ACCOUNT')}
                    </LoginBanner.Link>{' '}
                    {t('IF')}:
                </LoginBanner.Title>
                <LoginBanner.List>
                    <LoginBanner.ListItem>
                        {t('GUEST_REGISTER_LIST_TEXT_1')}
                    </LoginBanner.ListItem>
                    <LoginBanner.ListItem>
                        {t('GUEST_REGISTER_LIST_TEXT_2')}
                    </LoginBanner.ListItem>
                </LoginBanner.List>
            </LoginBanner>
        </ColumnsLayout>
    );
};
